import React from "react";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import {Grid, Tabs, Tab, Box} from "@mui/material";
import Loading from "../components/common/Loading";
import {useTranslation} from "react-i18next";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import PickUpDeliverySchedules from "../components/management/PickUpDeliverySchedules";
import StayConfiguration from "./StayConfiguration";
import EmailsConfiguration from "./EmailsConfiguration";
import {useSearchParams} from "react-router-dom";
import ConfigurationParameterPage from "./ConfigurationParameterPage";
import {useTenantConfig} from "../security/tenant-config-context";
import ContractTemplateEditor from "./ContractTemplateEditor";
import ServicesList from "./appointments/ServicesList";
import StaffList from "./appointments/StaffList";

const TABS = ["stays", "schedules", "services", "staffAndPlanning", "emails", "contracts", "configuratieparameters"];

const Configuratie = () => {
    const {t} = useTranslation();
    const [params, setParams] = useSearchParams();
    const value = TABS.includes(params.get("tab")) ? params.get("tab") : "stays";
    const {cfg} = useTenantConfig();
    const isAppointmentFlow = cfg?.businessTypes?.includes('APPOINTMENT_BASED');

    const handleTabChange = (_e, newValue) => {
        params.set("tab", newValue);
        setParams(params, {replace: true});
    };

    return (
        <>
            <Grid container justifyContent="center" sx={{px: {xs: 1, sm: 2}, py: {xs: 1, sm: 2}}}>
                <Grid item xs={12} sm={12} sx={{p: 2, m: 2}}>
                    <TabContext value={value}>
                        <Box sx={{display: 'flex', justifyContent: 'center', mb: 2}}>
                            <Tabs value={value} onChange={handleTabChange} aria-label="Pet detail tabs" data-testid="config-tabs">
                                {!isAppointmentFlow && (<Tab label={t('stays')} value="stays" data-testid="tab-stays"/>)}
                                {isAppointmentFlow && (<Tab label={t('services')} value="services" data-testid="tab-services"/>)}
                                {isAppointmentFlow && (<Tab label={t('staffAndPlanning')} value="staffAndPlanning" data-testid="tab-staffAndPlanning"/>)}
                                {!isAppointmentFlow && (<Tab label={t('checkInCheckOut')} value="schedules" data-testid="tab-schedules"/>)}
                                <Tab label={t('emails')} value="emails" data-testid="tab-emails"/>
                                {!isAppointmentFlow && (<Tab label={t('contracts')} value="contracts" data-testid="tab-contracts"/>)}
                                <Tab label={t('configuratieparameters')} value="configuratieparameters" data-testid="tab-config-parameters"/>
                            </Tabs>
                        </Box>

                        {/* Panels: altijd volle breedte en links uitlijnen */}
                        <TabPanel value="stays" sx={{p: 0, m: 0, width: '100%', textAlign: 'left'}}>
                            {!isAppointmentFlow ? <StayConfiguration/> : <ServicesList/>}
                        </TabPanel>
                        <TabPanel value="schedules" sx={{p: 0, m: 0, width: '100%', textAlign: 'left'}}>
                            <PickUpDeliverySchedules/>
                        </TabPanel>
                        <TabPanel value="services" sx={{p: 0, m: 0, width: '100%', textAlign: 'left'}}>
                            <ServicesList/>
                        </TabPanel>
                        <TabPanel value="staffAndPlanning" sx={{p: 0, m: 0, width: '100%', textAlign: 'left'}}>
                            <StaffList/>
                        </TabPanel>
                        <TabPanel value="emails" sx={{p: 0, m: 0, width: '100%', textAlign: 'left'}}>
                            <EmailsConfiguration/>
                        </TabPanel>
                        <TabPanel value="contracts" sx={{p: 0, m: 0, width: '100%', textAlign: 'left'}}>
                            <ContractTemplateEditor/>
                        </TabPanel>
                        <TabPanel value="configuratieparameters" sx={{p: 0, m: 0, width: '100%', textAlign: 'left'}}>
                            <ConfigurationParameterPage/>
                        </TabPanel>
                    </TabContext>
                </Grid>
            </Grid>
        </>
    );
};

export default withAuthenticationRequired(Configuratie, {
    onRedirecting: () => <Loading/>,
    returnTo: "/beheer/login"
});
